import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";



const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
    {/* <Provider store={store}> */}
      {/* <ConfigProvider  
        theme={{
          
          // algorithm: isdarkMode? theme.darkAlgorithm: '',

          token: {
            
            colorPrimary: "#ffffff",
            borderRadius: 2,
            colorBgContainer: "#000000",
          },

         

        }}

        
      > */}
        <App />
      {/* </ConfigProvider> */}
    {/* </Provider> */}
  </React.StrictMode>
);


